import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Header from '../../../components/feature/Header';
import Footer from '../../../components/feature/Footer';
import FloatingButtons from '../../../components/feature/FloatingButtons';

const HizmetLaboratuvariPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
    
    // SEO Meta Tags
    document.title = 'Basit Hizmet Laboratuvarı Adana Mersin Hatay Osmaniye | ASSA OSGB';
    
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'Adana OSGB, Mersin OSGB, Hatay OSGB, Osmaniye OSGB basit hizmet laboratuvarı. Kan tahlili, idrar tahlili, sağlık testleri. ASSA OSGB laboratuvar hizmetleri.');
    }

    const metaKeywords = document.querySelector('meta[name="keywords"]');
    if (metaKeywords) {
      metaKeywords.setAttribute('content', 'Adana laboratuvar, Mersin laboratuvar, Hatay laboratuvar, Osmaniye laboratuvar, OSGB laboratuvar hizmetleri');
    }

    // Canonical URL
    const canonical = document.querySelector('link[rel="canonical"]');
    if (canonical) {
      canonical.setAttribute('href', `${import.meta.env.VITE_SITE_URL || 'https://example.com'}/laboratuvar/hizmet-laboratuvari`);
    }

    // Schema.org JSON-LD
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.textContent = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "MedicalBusiness",
      "name": "ASSA OSGB Basit Hizmet Laboratuvarı",
      "description": "Adana, Mersin, Hatay, Osmaniye bölgelerinde basit hizmet laboratuvarı ve sağlık testleri",
      "provider": {
        "@type": "Organization",
        "name": "ASSA OSGB",
        "telephone": "0850 346 2772",
        "email": "assa@assaisg.com"
      },
      "areaServed": [
        {
          "@type": "City",
          "name": "Adana"
        },
        {
          "@type": "City",
          "name": "Mersin"
        },
        {
          "@type": "City",
          "name": "Hatay"
        },
        {
          "@type": "City",
          "name": "Osmaniye"
        }
      ],
      "serviceType": "Hizmet Laboratuvarı",
      "url": `${import.meta.env.VITE_SITE_URL || 'https://example.com'}/laboratuvar/hizmet-laboratuvari`
    });
    document.head.appendChild(script);

    return () => {
      document.head.removeChild(script);
    };
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Header />
      <FloatingButtons />

      {/* Hero Section */}
      <section 
        className="pt-24 pb-16 bg-cover bg-center relative"
        style={{
          backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url('https://public.readdy.ai/ai/img_res/0922dd655f1809de13ea643a56cb73e5.jpg')`
        }}
      >
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto text-center text-white">
            <h1 className="text-4xl md:text-5xl font-bold mb-6">
              Basit Hizmet Laboratuvarı
            </h1>
            <p className="text-xl mb-8">
              <strong>Adana OSGB</strong>, <strong>Mersin OSGB</strong>, <strong>Hatay OSGB</strong> ve <strong>Osmaniye OSGB</strong> bölgelerinde modern teknoloji ile donatılmış hizmet laboratuvarımızda güvenilir sağlık testleri sunuyoruz.
            </p>
          </div>
        </div>
      </section>

      {/* Services Section */}
      <section className="py-16 bg-white">
        <div className="container mx-auto px-4">
          <div className="max-w-6xl mx-auto">
            <h2 className="text-3xl font-bold text-gray-900 mb-12 text-center">
              Laboratuvar Hizmetlerimiz
            </h2>

            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
              {/* Service Card 1 */}
              <div className="bg-gray-50 rounded-xl p-6 hover:shadow-lg transition-shadow">
                <div className="w-14 h-14 bg-blue-100 rounded-lg flex items-center justify-center mb-4">
                  <i className="ri-drop-line text-2xl text-blue-600"></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">Kan Tahlilleri</h3>
                <p className="text-gray-600">
                  Tam kan sayımı, biyokimya paneli, hormon testleri ve özel kan analizleri. <strong>Adana laboratuvar</strong> hizmetlerimizde hızlı ve güvenilir sonuçlar.
                </p>
              </div>

              {/* Service Card 2 */}
              <div className="bg-gray-50 rounded-xl p-6 hover:shadow-lg transition-shadow">
                <div className="w-14 h-14 bg-blue-100 rounded-lg flex items-center justify-center mb-4">
                  <i className="ri-test-tube-line text-2xl text-blue-600"></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">İdrar Analizleri</h3>
                <p className="text-gray-600">
                  Tam idrar tahlili, mikroskobik inceleme ve özel idrar testleri. <strong>Mersin OSGB laboratuvar</strong> standartlarında hizmet.
                </p>
              </div>

              {/* Service Card 3 */}
              <div className="bg-gray-50 rounded-xl p-6 hover:shadow-lg transition-shadow">
                <div className="w-14 h-14 bg-blue-100 rounded-lg flex items-center justify-center mb-4">
                  <i className="ri-microscope-line text-2xl text-blue-600"></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">Mikrobiyoloji Testleri</h3>
                <p className="text-gray-600">
                  Enfeksiyon hastalıkları tanısı, kültür ve antibiyogram testleri. <strong>Hatay OSGB</strong> bölgesinde uzman kadromuzla hizmet.
                </p>
              </div>

              {/* Service Card 4 */}
              <div className="bg-gray-50 rounded-xl p-6 hover:shadow-lg transition-shadow">
                <div className="w-14 h-14 bg-blue-100 rounded-lg flex items-center justify-center mb-4">
                  <i className="ri-heart-line text-2xl text-blue-600"></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">Kardiyoloji Testleri</h3>
                <p className="text-gray-600">
                  EKG, ekokardiyografi ve kardiyak marker testleri. <strong>Osmaniye laboratuvar</strong> hizmetlerimizde kalp sağlığı takibi.
                </p>
              </div>

              {/* Service Card 5 */}
              <div className="bg-gray-50 rounded-xl p-6 hover:shadow-lg transition-shadow">
                <div className="w-14 h-14 bg-blue-100 rounded-lg flex items-center justify-center mb-4">
                  <i className="ri-lungs-line text-2xl text-blue-600"></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">Solunum Fonksiyon Testleri</h3>
                <p className="text-gray-600">
                  Spirometri, akciğer kapasitesi ölçümü ve solunum yolu değerlendirmesi. <strong>Adana OSGB</strong> standartlarında test.
                </p>
              </div>

              {/* Service Card 6 */}
              <div className="bg-gray-50 rounded-xl p-6 hover:shadow-lg transition-shadow">
                <div className="w-14 h-14 bg-blue-100 rounded-lg flex items-center justify-center mb-4">
                  <i className="ri-eye-line text-2xl text-blue-600"></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">Görme Testleri</h3>
                <p className="text-gray-600">
                  Görme keskinliği, renk körlüğü ve göz muayeneleri. <strong>Mersin laboratuvar</strong> hizmetlerimizde kapsamlı göz sağlığı.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Technology Section */}
      <section className="py-16 bg-gray-50">
        <div className="container mx-auto px-4">
          <div className="max-w-6xl mx-auto">
            <div className="grid lg:grid-cols-2 gap-12 items-center">
              <div>
                <h2 className="text-3xl font-bold text-gray-900 mb-6">
                  Modern Teknoloji ve Uzman Kadro
                </h2>
                <p className="text-gray-600 mb-6">
                  <strong>ASSA OSGB Hizmet Laboratuvarı</strong> olarak, <strong>Adana</strong>, <strong>Mersin</strong>, <strong>Hatay</strong> ve <strong>Osmaniye</strong> bölgelerinde en son teknoloji ile donatılmış laboratuvarımızda hizmet veriyoruz.
                </p>
                <div className="space-y-4">
                  <div className="flex items-start">
                    <div className="w-6 h-6 bg-blue-100 rounded-full flex items-center justify-center mt-1 mr-3">
                      <i className="ri-check-line text-blue-600 text-sm"></i>
                    </div>
                    <div>
                      <h4 className="font-bold text-gray-900">Otomatik Analiz Cihazları</h4>
                      <p className="text-gray-600">Son teknoloji otomatik analiz cihazları ile hızlı ve doğru sonuçlar</p>
                    </div>
                  </div>
                  <div className="flex items-start">
                    <div className="w-6 h-6 bg-blue-100 rounded-full flex items-center justify-center mt-1 mr-3">
                      <i className="ri-check-line text-blue-600 text-sm"></i>
                    </div>
                    <div>
                      <h4 className="font-bold text-gray-900">Kalite Kontrol Sistemi</h4>
                      <p className="text-gray-600">Uluslararası standartlarda kalite kontrol ve güvence sistemi</p>
                    </div>
                  </div>
                  <div className="flex items-start">
                    <div className="w-6 h-6 bg-blue-100 rounded-full flex items-center justify-center mt-1 mr-3">
                      <i className="ri-check-line text-blue-600 text-sm"></i>
                    </div>
                    <div>
                      <h4 className="font-bold text-gray-900">Uzman Laboratuvar Teknisyenleri</h4>
                      <p className="text-gray-600">Deneyimli ve sertifikalı laboratuvar teknisyenleri</p>
                    </div>
                  </div>
                </div>
              </div>
              <div>
                <img 
                  src="https://readdy.ai/api/search-image?query=Professional%20laboratory%20technician%20working%20with%20modern%20medical%20equipment%2C%20clean%20laboratory%20environment%2C%20advanced%20testing%20machines%2C%20healthcare%20professional%20in%20white%20coat%2C%20precise%20medical%20testing%2C%20sterile%20laboratory%20conditions%2C%20scientific%20accuracy&width=600&height=400&seq=lab-tech-001&orientation=landscape"
                  alt="Laboratuvar Teknolojisi"
                  className="rounded-xl shadow-lg object-cover w-full h-80"
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Regional Coverage */}
      <section className="py-16 bg-white">
        <div className="container mx-auto px-4">
          <div className="max-w-6xl mx-auto">
            <h2 className="text-3xl font-bold text-gray-900 mb-12 text-center">
              Hizmet Bölgelerimiz
            </h2>

            <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
              <div className="bg-gray-50 rounded-xl p-6 text-center hover:shadow-lg transition-shadow">
                <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-hospital-line text-3xl text-blue-600"></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-2">Adana Laboratuvar</h3>
                <p className="text-gray-600">
                  Adana ve çevresinde <strong>hizmet laboratuvarı</strong> desteği
                </p>
              </div>

              <div className="bg-gray-50 rounded-xl p-6 text-center hover:shadow-lg transition-shadow">
                <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-hospital-line text-3xl text-blue-600"></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-2">Mersin Laboratuvar</h3>
                <p className="text-gray-600">
                  Mersin bölgesinde profesyonel <strong>laboratuvar hizmetleri</strong>
                </p>
              </div>

              <div className="bg-gray-50 rounded-xl p-6 text-center hover:shadow-lg transition-shadow">
                <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-hospital-line text-3xl text-blue-600"></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-2">Hatay Laboratuvar</h3>
                <p className="text-gray-600">
                  Hatay'da güvenilir <strong>sağlık testleri</strong> ve analizler
                </p>
              </div>

              <div className="bg-gray-50 rounded-xl p-6 text-center hover:shadow-lg transition-shadow">
                <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-hospital-line text-3xl text-blue-600"></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-2">Osmaniye Laboratuvar</h3>
                <p className="text-gray-600">
                  Osmaniye'de modern <strong>laboratuvar teknolojisi</strong>
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Process Section */}
      <section className="py-16 bg-gray-50">
        <div className="container mx-auto px-4">
          <div className="max-w-6xl mx-auto">
            <h2 className="text-3xl font-bold text-gray-900 mb-12 text-center">
              Test Süreci
            </h2>

            <div className="grid md:grid-cols-4 gap-6">
              <div className="text-center">
                <div className="w-16 h-16 bg-blue-600 rounded-full flex items-center justify-center mx-auto mb-4">
                  <span className="text-white font-bold text-xl">1</span>
                </div>
                <h3 className="text-lg font-bold text-gray-900 mb-2">Randevu Alma</h3>
                <p className="text-gray-600">Online veya telefon ile kolayca randevu alın</p>
              </div>

              <div className="text-center">
                <div className="w-16 h-16 bg-blue-600 rounded-full flex items-center justify-center mx-auto mb-4">
                  <span className="text-white font-bold text-xl">2</span>
                </div>
                <h3 className="text-lg font-bold text-gray-900 mb-2">Numune Alma</h3>
                <p className="text-gray-600">Steril koşullarda profesyonel numune alma</p>
              </div>

              <div className="text-center">
                <div className="w-16 h-16 bg-blue-600 rounded-full flex items-center justify-center mx-auto mb-4">
                  <span className="text-white font-bold text-xl">3</span>
                </div>
                <h3 className="text-lg font-bold text-gray-900 mb-2">Analiz Süreci</h3>
                <p className="text-gray-600">Modern cihazlarla hızlı ve doğru analiz</p>
              </div>

              <div className="text-center">
                <div className="w-16 h-16 bg-blue-600 rounded-full flex items-center justify-center mx-auto mb-4">
                  <span className="text-white font-bold text-xl">4</span>
                </div>
                <h3 className="text-lg font-bold text-gray-900 mb-2">Sonuç Teslimi</h3>
                <p className="text-gray-600">Online veya fiziki olarak sonuç teslimi</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-16 bg-blue-600">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto text-center">
            <h2 className="text-3xl md:text-4xl font-bold text-white mb-6">
              Laboratuvar Hizmeti Almak İster misiniz?
            </h2>
            <p className="text-xl text-white/90 mb-8">
              <strong>Adana OSGB</strong>, <strong>Mersin OSGB</strong>, <strong>Hatay OSGB</strong> ve <strong>Osmaniye OSGB</strong> bölgelerinde güvenilir laboratuvar hizmetleri için bizimle iletişime geçin.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Link 
                to="/iletisim" 
                className="bg-white text-blue-600 px-8 py-4 rounded-lg font-bold hover:bg-gray-100 transition-colors whitespace-nowrap"
              >
                Hemen İletişime Geçin
              </Link>
              <a 
                href="tel:08503462772" 
                className="bg-blue-700 text-white px-8 py-4 rounded-lg font-bold hover:bg-blue-800 transition-colors whitespace-nowrap"
              >
                <i className="ri-phone-line mr-2"></i>
                0850 346 2772
              </a>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default HizmetLaboratuvariPage;